// todo remove suppression on multiple exports
// eslint-disable-next-line import/prefer-default-export
export const options = [
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'Français' },
];

export const langs = {
  'en': 'English',
  'fr': 'Français',
}
